export default __webpack_public_path__ + "e4aa73b593f0719214d0f6bc36ae0123.svg";